/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import {
    Icon,
    Button,
    Stack,
    FlexRow,
    FlexCol,
    ButtonGroup,
    SecurityHelper,
} from 'sarsaparilla';

const propTypes = {
    searchCriteria: PropTypes.object,
    onApply: PropTypes.func,
    onClose: PropTypes.func,
    onClear: PropTypes.func,
};

const defaultProps = {};

export default class DivisionFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: props.searchCriteria.searchText,
            areas: Object.assign([], props.searchCriteria.areas),
            motorSize: props.searchCriteria.motorSize,
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleMotorSizeChange = this.handleMotorSizeChange.bind(this);
        this.handleAreaChange = this.handleAreaChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onApply = this.onApply.bind(this);
        this.onClear = this.onClear.bind(this);
    }

    onClose() {
        this.props.onClose();
    }

    onApply() {
        this.props.onApply(this.state.searchText, this.state.areas, this.state.motorSize);
    }

    onClear() {
        this.setState({
            searchText: '',
            areas: [],
            motorSize: null,
        });
        this.props.onClear();
    }

    handleSearchChange(event) {
        const value = event.target.value;
        this.setState({
            searchText: value,
        });
    }

    handleMotorSizeChange(value) {
        this.setState({
            motorSize: value,
        });
    }

    handleAreaChange(value) {
        const areas = this.state.areas;
        if (areas.indexOf(value) >= 0) {
            areas.splice(areas.indexOf(value), 1);
        } else {
            areas.push(value);
        }
        this.setState({ areas });
    }

    render() {
        return (
            <Stack className="per-availability-filters-dropdown">
                <div className="rec-filter-flex-wrap">
                    <label htmlFor="division-search-input">Search</label>
                    <div className="filter-options">
                        <input
                            type="text"
                            id="division-search-input"
                            value={this.state.searchText}
                            onChange={this.handleSearchChange}
                            placeholder="Search entrance name, Trout Lake, etc..."
                        />
                    </div>
                </div>

                <div className="rec-filter-flex-wrap" role="group">
                    <legend id="area-filter">Area</legend>
                    <div
                        className="rec-check-buttons-wrap"
                        role="group"
                        aria-label="Select Area(s)"
                    >
                        <label htmlFor="checkbox-Gunflint">
                            <input
                                type="checkbox"
                                aria-label="Gunflint"
                                className="rec-input-hide"
                                id="checkbox-Gunflint"
                                name="checkbox"
                                checked={this.state.areas.indexOf('Gunflint') >= 0}
                                onChange={this.handleAreaChange.bind(this, 'Gunflint')}
                                value="Gunflint"
                            />
                            <span>Gunflint</span>
                        </label>
                        <label htmlFor="checkbox-LaCroix">
                            <input
                                type="checkbox"
                                aria-label="LaCroix"
                                className="rec-input-hide"
                                id="checkbox-LaCroix"
                                name="checkbox"
                                checked={this.state.areas.indexOf('LaCroix') >= 0}
                                onChange={this.handleAreaChange.bind(this, 'LaCroix')}
                                value="LaCroix"
                            />
                            <span>LaCroix</span>
                        </label>
                        <label htmlFor="checkbox-Kawishiwi">
                            <input
                                type="checkbox"
                                aria-label="Kawishiwi"
                                className="rec-input-hide"
                                id="checkbox-Kawishiwi"
                                name="checkbox"
                                checked={this.state.areas.indexOf('Kawishiwi') >= 0}
                                onChange={this.handleAreaChange.bind(this, 'Kawishiwi')}
                                value="Kawishiwi"
                            />
                            <span>Kawishiwi</span>
                        </label>
                        <label htmlFor="checkbox-Tofte">
                            <input
                                type="checkbox"
                                aria-label="Tofte"
                                className="rec-input-hide"
                                id="checkbox-Tofte"
                                name="checkbox"
                                checked={this.state.areas.indexOf('Tofte') >= 0}
                                onChange={this.handleAreaChange.bind(this, 'Tofte')}
                                value="Tofte"
                            />
                            <span>Tofte</span>
                        </label>
                    </div>
                </div>
                <FlexRow>
                    <FlexCol xs={12} md={6} className="mb-2">
                        <ButtonGroup align="left">
                            <Button
                                appearance="link"
                                onClick={this.onClear}
                                iconAfterElement={<Icon iconName="loop" />}
                            >
                                Clear All Filters
                            </Button>
                        </ButtonGroup>
                    </FlexCol>
                    <FlexCol xs={12} md={6}>
                        <ButtonGroup align="right">
                            <Button
                                className="rec-button-link"
                                appearance="tertiary"
                                onClick={this.onClose}
                            >
                                Close
                            </Button>
                            <Button onClick={this.onApply}>
                                {SecurityHelper.isMobileApp()
                                    ? 'Apply Filters'
                                    : 'Show Results'}
                            </Button>
                        </ButtonGroup>
                    </FlexCol>
                </FlexRow>
            </Stack>
        );
    }
}

DivisionFilters.propTypes = propTypes;
DivisionFilters.defaultProps = defaultProps;
